import React, {useContext} from "react";
import { createPortal } from "react-dom";
import {ConfirmationPopup} from "./ConfirmationPopup";
import {BaselineConfirmationPopup} from "./BaselineConfirmationPopup";
import {RemoveDevicePopup} from "./RemoveDevicePopup";
import {DeleteConfirmationPopup} from "./DeleteConfirmationPopup";
import {PopupContext} from "../../index";
import CreateEventPopup from "../../rules/syslog-settings/CreateEventPopup";
import EditEventPopup from "../../rules/syslog-settings/EditEventPopup";
import CreateParameterPopup from "../../rules/parameters/CreateParameterPopup";
import EditParameterPopup from "../../rules/parameters/EditParameterPopup";
import CreateNotePopup from "../../rules/validate/CreateNotePopup";
import EditNotePopup from "../../rules/validate/EditNotePopup";
import CreateEventOnAddDevicePopup from "../../devices/add-device-modal/CreateEventOnAddDevicePopup";
import { ClosePopup } from "./ClosePopup";
import SaveRulePopup from "../../rules/add-rules/SaveRulePopup";
import ViewRuleOutputPopup from "../../rules/validate/ViewRuleOutputPopup";
import RemediationOutputPopup from "../../rules/remediation/RemediationOutputPopup";
import AuthServerCheckConnectivityPopup from "../../auth/authserver/AuthServerCheckConnectivityPopup";
import BaselineDialogResultPopup from "../../devices/BaselineResultDialogPopup";
import AboutPopup from "../header/AboutPopup";
import ViewScanOutputPopup from "../../networkscan/vulnerabilityscan/ViewScanOutputPopup";
import UpdateOSPopup from "../../networkscan/networkinventory/UpdateOSPopup";
import CopyMoveToMsbPopup from "../../rules/msb/CopyMoveToMsbPopup";
import AddAcknowledgeExpiryDatePopup from "../../rules/validate/AddAcknowledgeExpiryDatePopup";
import ConfigActionImpactPopup from "../../mllogincountdetectionresults/ConfigActionImpactPopup";

export const POPUP_TYPES = {
    BASELINECONFIRM: "BaselineConfirmationPopup",
    CONFIRM: "ConfirmationPopup",
    REMOVE_DEVICE_CONFIRM: "RemoveDevicePopup",
    DELETE_CONFIRM: "DeleteConfirmationPopup",
    CREATE_EVENT: "CreateEvent",
    EDIT_EVENT: "EditEvent",
    CREATE_PARAMETER: "CreateParameter",
    EDIT_PARAMETER: "EditParameter",
    ADD_NOTE: "Add Note",
    EDIT_NOTE: "Edit Note",
    CLOSE_POPUP: "Close Popup",
    SAVE_RULE_POPUP: "Save Rule Popup",
    CREATE_EVENT_ON_ADD_DEVICE: "CreateEventOnAddDevice",
    VIEW_RULE_OUTPUT: "ViewRuleOutput",
    REMEDIATION_OUTPUT: "RemediationOutput",
    AUTH_SERVER_CHECK_CONNECTIVITY: "AuthServerCheckConnectivity",
    BASELINE_DIALOG_RESULT:"BaselineDialogResultPopup",
    VIEW_NMAP_SCAN_OUTPUT: "ViewScanOutput",
    UPDATE_OS: "UpdateOS",
    COPY_TO_MSB: "CopyToMsb",
    ADD_ACKNOWLEDGE_EXPIRY_DATE: "AddAcknowledgeExpiryDate",
    CONFIG_ACTION_IMPACT: "ConfigActionImpact"
}

export default function PopupContainer() {

    const {popup, setPopup} = useContext(PopupContext);

    if (!popup) {
        return null;
    }

    const showPopup = (popup) => {
        switch (popup.type) {
            case POPUP_TYPES.CONFIRM:
                return <ConfirmationPopup
                    message={popup.message}
                    title={popup.title}
                    note={popup.note}
                    confirmLabel={popup.confirmLabel}
                    onCancel={popup.onCancel}
                    onSubmit={popup.onSubmit}
                    closePopup={() => setPopup(null)}
                />;
            case POPUP_TYPES.REMOVE_DEVICE_CONFIRM:
                return <RemoveDevicePopup
                    title={popup.title}
                    onCancel={popup.onCancel}
                    onSubmit={popup.onSubmit}
                    closePopup={() => setPopup(null)}
                    deviceCount={popup.deviceCount}
                />;
            case POPUP_TYPES.DELETE_CONFIRM:
                return <DeleteConfirmationPopup
                    title={popup.title}
                    message={popup.message}
                    note={popup.note}
                    confirmLabel={popup.confirmLabel}
                    onCancel={popup.onCancel}
                    onSubmit={popup.onSubmit}
                    closePopup={() => setPopup(null)}
                />;
                case POPUP_TYPES.BASELINECONFIRM:
                return <BaselineConfirmationPopup
                    deviceName={popup.deviceName}
                    msbName={popup.msbName}
                    onCancel={popup.onCancel}
                    onSubmit={popup.onSubmit}
                    closePopup={() => setPopup(null)}
                />;
            case POPUP_TYPES.CREATE_EVENT:
                return <CreateEventPopup closePopup={() => setPopup(null)} {...popup}/>
            case POPUP_TYPES.EDIT_EVENT:
                return <EditEventPopup closePopup={() => setPopup(null)} {...popup}/>

            case POPUP_TYPES.CREATE_PARAMETER:
                return <CreateParameterPopup closePopup={() => setPopup(null)} {...popup}/>
            case POPUP_TYPES.EDIT_PARAMETER:
                return <EditParameterPopup closePopup={() => setPopup(null)} {...popup}/>  
            
            case POPUP_TYPES.ADD_NOTE:
                return <CreateNotePopup closePopup={() => setPopup(null)} {...popup}/>
            case POPUP_TYPES.EDIT_NOTE:
                return <EditNotePopup closePopup={() => setPopup(null)} {...popup}/>

            case POPUP_TYPES.ADD_ACKNOWLEDGE_EXPIRY_DATE:
                return <AddAcknowledgeExpiryDatePopup closePopup={() => setPopup(null)} {...popup}/>
            //Network Scan Changing OS
            case POPUP_TYPES.UPDATE_OS:
                return <UpdateOSPopup closePopup={() => setPopup(null)} {...popup}/>
                
            case POPUP_TYPES.ABOUT:
                return <AboutPopup closePopup={() => setPopup(null)} {...popup}/>

            case POPUP_TYPES.CLOSE_POPUP:
                return <ClosePopup  
                title={popup.title}
                message={popup.message}
                onCancel={popup.onCancel}
                closePopup={() => setPopup(null)}
                />

            case POPUP_TYPES.SAVE_RULE_POPUP:
                return <SaveRulePopup closePopup={() => setPopup(null)} {...popup}/>    
            
            case POPUP_TYPES.CREATE_EVENT_ON_ADD_DEVICE:
                return <CreateEventOnAddDevicePopup closePopup={() => setPopup(null)} {...popup}/>
            
            case POPUP_TYPES.VIEW_RULE_OUTPUT:
                return <ViewRuleOutputPopup closePopup={() => setPopup(null)} {...popup}/>             
            
            case POPUP_TYPES.REMEDIATION_OUTPUT:
                return <RemediationOutputPopup closePopup={() => setPopup(null)} {...popup}/>
                
            case POPUP_TYPES.AUTH_SERVER_CHECK_CONNECTIVITY:
                return <AuthServerCheckConnectivityPopup closePopup={() => setPopup(null)} {...popup}/>

            case POPUP_TYPES.BASELINE_DIALOG_RESULT:
                return <BaselineDialogResultPopup closePopup={() => setPopup(null)} {...popup}/>    

            case POPUP_TYPES.VIEW_NMAP_SCAN_OUTPUT:
                return <ViewScanOutputPopup closePopup={() => setPopup(null)} {...popup}/>

            case POPUP_TYPES.COPY_TO_MSB:
                return <CopyMoveToMsbPopup title={popup.title} closePopup={() => setPopup(null)} {...popup}/>

            case POPUP_TYPES.CONFIG_ACTION_IMPACT:
                return <ConfigActionImpactPopup closePopup={() => setPopup(null)} {...popup}/>
        
            default:
            return null
        }
    }

    return createPortal(
        <div className="oct_targetmodal oct_targetmodal--top oct_display-block">
            {showPopup(popup)}
        </div>,
        document.body
    )

}

export function getConfirmPopup(message, title, onSubmit, onCancel, confirmLabel = "Continue", note = null) {
    return {
        type: POPUP_TYPES.CONFIRM,
        message: message,
        title: title,
        note: note,
        confirmLabel: confirmLabel,
        onSubmit: onSubmit,
        onCancel: onCancel
    }
}

export function getBaselineConfirmPopup(deviceName, msbName, onSubmit, onCancel) {
    return {
        type: POPUP_TYPES.BASELINECONFIRM,
        deviceName: deviceName,
        msbName: msbName,
        onSubmit: onSubmit,
        onCancel: onCancel
    }
}

export function getRemoveDevicePopup(title, deviceCount, onSubmit, onCancel) {
    return {
        type: POPUP_TYPES.REMOVE_DEVICE_CONFIRM,
        title: title,
        deviceCount: deviceCount,
        onSubmit: onSubmit,
        onCancel: onCancel
    }
}

export function getDeletePopup(message, title, onSubmit, onCancel, confirmLabel = "Delete", note = "This action cannot be undone.") {
    return {
        type: POPUP_TYPES.DELETE_CONFIRM,
        message: message,
        title: title,
        onSubmit: onSubmit,
        onCancel: onCancel,
        confirmLabel: confirmLabel,
        note: note
    }
}

export function getClosePopup(message, title, onCancel) {
    return {
        type: POPUP_TYPES.CLOSE_POPUP,
        message: message,
        title: title,
        onCancel: onCancel
    }
}

export function getConfigActionImpactPopup(data) {
    return {
        type: POPUP_TYPES.CONFIG_ACTION_IMPACT,
        data,
    }
}
